// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"h8-z"};